<div class="p-fluid p-formgrid p-grid">
  <div class="p-col-12 p-lg-3 p-mb-4">
    <p-card header="Filtros" (keyup)="ds.onEnterPesquisar($event)">
      <div class="p-grid">
        <m-restricao-number label="Id" [restricao]="ds.restricoes.atributo('id')"></m-restricao-number>
        <m-restricao-string label="Autor"  [restricao]="ds.restricoes.atributo('autor')"></m-restricao-string>
        <m-restricao-string label="Arquivo"  [restricao]="ds.restricoes.atributo('arquivo')"></m-restricao-string>
        <m-restricao-string label="Descricao"  [restricao]="ds.restricoes.atributo('descricao')"></m-restricao-string>
      </div>
      <p-footer>
        <div class="p-fluid p-grid">
          <div class="p-field p-col">
            <button pButton label="Pesquisar" (click)="ds.pesquisar()"></button>
          </div>
          <div class="p-field p-col">
            <button pButton class="p-button-secondary" label="Limpar" (click)="ds.limpar()"></button>
          </div>
        </div>
      </p-footer>
    </p-card>
  </div>
  <div class="p-col-12 p-lg-9">
    <p-card class="fonte-dados-card" header="Lista de Registro de Alterações no Banco de Dados">
      <p-table
        [multiSortMeta]="ds.ordenacoes"
        [value]="ds.entidades"
        dataKey="id"
        [totalRecords]="ds.total"
        (onLazyLoad)="ds.carregar($event)"
        [lazy]="true"
        [(rows)]="ds.registros"
        [paginator]="true"
        responsive="true"
        sortField="dataExecucao"
        sortMode="multiple"
        [sortOrder]="-1"
        responsiveLayout="scroll"
        styleClass="tabela-fonte-dados p-datatable-striped"
        emptyMessage="Nenhum registro encontrado">
        <ng-template pTemplate="header">
            <tr>
              <th style="width: 60px"></th>
              <th pSortableColumn="id" style="text-align: center; width: 10%">ID <p-sortIcon field="id"></p-sortIcon></th>
              <th pSortableColumn="autor" style="text-align: center; width: 30%">Autor <p-sortIcon field="autor"></p-sortIcon></th>
              <th pSortableColumn="dataExecucao" style="text-align: center; width: 30%">Data de Execução <p-sortIcon field="dataExecucao"></p-sortIcon></th>
              <th pSortableColumn="arquivo" style="text-align: center; width: 30%">Arquivo <p-sortIcon field="arquivo"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-entidade let-expanded="expanded">
          <tr>
            <td>
              <button type="button" pButton pRipple [pRowToggler]="entidade" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            </td>
            <td class="p-text-center">{{entidade.id}}</td>
            <td class="text-left">{{entidade.autor}}</td>
            <td class="text-left">{{ entidade.dataExecucao | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            <td class="quebra-texto text-left">{{entidade.arquivo}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-entidade>
          <tr>
            <td colspan="7">
              <div class="quebra-texto p-mb-2">
                <span class="p-text-bold">
                  Ordem Execução:
                </span>
                {{ entidade.ordemExecucao }}
              </div>
              <div class="quebra-texto p-mb-2">
                <span class="p-text-bold">
                  Md5Sum:
                </span>
                {{ entidade.md5Sum }}
              </div>
              <div class="quebra-texto">
                <span class="p-text-bold">
                  Descricao:
                </span>
                {{ entidade.descricao }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>
